<template>
  <a class="l_coupon__card" @click="action">
    <div class="l_coupon__header">
      <!-- プレミアム -->
      <template>
        <div class="l_category">
          <div class="inner">
            <img src="~@/assets/img/premium/icon_coupon.svg" />
          </div>
          <div class="inner">
            <span class="c_category__label">{{ this.categoryName }}</span>
          </div>
        </div>
      </template>
      <!-- 有効期限 -->
      <div class="c_coupon__expire l_expireAt">
        <span class="c_expire__label">{{ this.expireAtStr }}</span>
      </div>
    </div>

    <!-- クーポン -->
    <div class="l_coupon">
      <template v-if="this.isLargeImage">
        <img :src="this.image" alt="" style="width: 100%">
      </template>
      <template v-else>
        <div
          class="l_coupon__left"
          :style="{ backgroundImage: 'url(' + this.image + ')' }"
        ></div>
        <div class="l_coupon__right">
          <div class="c_coupon__title">{{ this.title }}</div>
          <template v-if="this.isHtml">
            <div class="l_heading">
              <div class="c_coupon__subtitle" v-html="this.headingSmall"></div>
              <div
                class="c_coupon__heading"
                :class="{ is_android: isAndroid }"
                v-html="this.headingLarge"
              ></div>
            </div>
          </template>
          <template v-if="!this.isHtml">
            <div class="l_heading">
              <div class="c_coupon__subtitle">{{ this.headingSmall }}</div>
              <div class="c_coupon__heading" :class="{ is_android: isAndroid }">
                {{ this.headingLarge }}
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>
    <div class="l_coupon__footer">
      <a class="c_coupon__submit" v-if="this.type === '1'">ギフトを使う</a>
      <a class="c_coupon__submit" v-else-if="this.isOff"
        >クーポン利用可能期間外です</a
      >
      <a
        class="c_coupon__submit_expire"
        v-else-if="this.isExpiredDate(this.expireAt) === '1'"
      >
        <img src="@/assets/img/coupon/expire_use_coupon.png" />
      </a>
      <a class="c_coupon__submit_default" v-else
        ><img src="@/assets/img/coupon/use_coupon.png"
      /></a>
    </div>
  </a>
</template>

<script>
const categoryNames = ['何度でもご利用可能', '期間限定', '特典', 'あなただけ']
export default {
  name: 'PremiumCouponCard',
  props: {
    couponId: { type: String, required: true },
    expireAt: { type: String },
    image: { type: String },
    title: { type: String, required: true },
    subtitle: { type: String },
    headingSmall: { type: String },
    headingLarge: { type: String },
    isHtml: { type: Boolean },
    type: { type: String },
    giftExpire: { type: String },
    isOff: { type: Boolean },
    imageSize: { type: String },
    category: { type: String }
  },
  data: function () {
    return {
      currentCoupon: null,
      isAndroid: false
    }
  },
  mounted: function () {
    const ua = window.navigator.userAgent
    if (ua.indexOf('Android') >= 0) {
      this.isAndroid = true
    }
  },
  computed: {
    expireAtStr: function () {
      if (this.expireAt) {
        if (this.expireAt === '9999-12-31 23:59:59') {
          return '無期限'
        }

        const array = this.expireAt.split(' ')
        const date = array[0].split('-').join('/')
        const time = array[1].split(':')
        return `[有効期限] ${date} ${time[0]}:${time[1]}`
      } else {
        return `ー`
      }
    },
    isLargeImage: function () {
      return this.imageSize === '1'
    },
    categoryName: function () {
      return categoryNames[this.category]
    }
  },
  methods: {
    action() {
      this.$emit('click')
    },
    gotoUseCoupon: function (couponId) {
      /*
      this.currentCoupon = couponId
      try {
        if (typeof window.Android !== 'undefined' && window.Android !== null) {
          // call dialog in android
          if (this.errorState) {
            window.Android && window.Android.openErrorMessageDialog(this.currentCoupon, this.typeCoupon) // 2019-06-20 update - add new params
          } else {
            window.Android && window.Android.openLoadingPage(this.currentCoupon, this.typeCoupon) // 2019-06-20 update - add new params
          }
        } else {
          // call dialog in website
          if (this.errorState) { // errorState is static
            // データ取得に失敗した場合
            this.$router.push({ name: 'errorMessage', query: { id: this.currentCoupon, type: this.typeCoupon } }) // 2019-06-20 update - add new params
          } else {
            this.$router.push({ name: 'LoadingScreen', params: { callback: this.handleCouponClick, lastView: 'Coupon' } })
          }
        }
      } catch (err) {
        console.log(err + 'method: gotoUseCoupon')
      }
      */
    },
    handleCouponClick: function () {
      if (this.currentCoupon) {
        this.$router.push({
          path: '/coupon/' + this.currentCoupon,
          query: { type: this.typeCoupon }
        })
      }
    },
    __createExpiredDate(str) {
      const array = str.split(' ')
      const date = array[0].split('-').join('/')
      const time = array[1].split(':')
      return `${date} ${time[0]}:${time[1]}`
    },
    isExpiredDate(str) {
      const array = str.split(' ')
      const dateStr = array[0].split('-').join('/')
      const date1 = new Date(Date.now())
      const date2 = new Date(dateStr)
      if ((date2 - date1) / 86400000 < 7) {
        return '1'
      } else {
        return '0'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.l_coupon__card {
  margin-bottom: 10px;
  display: inline-block;
  width: 100%; /* 2019-06-21 - fixed */
}

/* header */
.l_coupon__header {
  width: 100%;
  height: 35px;
  display: flex; /* establish flex container */
  flex-direction: row; /* default value; can be omitted */
  flex-wrap: nowrap; /* default value; can be omitted */
  justify-content: space-between; /* switched from default (flex-start, see below) */
}

/* 有効期限 */
.l_expireAt {
  display: flex;
  align-items: center;
  padding: 0 0 0 10px;
}

.c_coupon__expire {
  background-color: #eeeeee;
  width: 60%;
  height: 35px;
  border-top-right-radius: 10px;
  font-size: 11px;
}

/* カテゴリーラベル */

.l_category {
  display: flex;
  align-items: center;
  width: 40%;
  height: 35px;
  border-top-left-radius: 10px;
  justify-content: center;
  background-image: url('~@/assets/img/premium/tab_on.png');
  background-size: cover;
  background-position: center;

  .inner {
    display: flex;
    margin: 0 2px;
  }
}

.c_expire__label {
  font-family: 'HiraKakuPro-W6';
  font-size: 11px;
  color: #666;
}

.c_category__label {
  font-family: 'HiraKakuPro-W6';
  font-weight: bold;
  font-size: 11px;
  color: #ffffff;
}

/* クーポン */

.l_coupon {
  display: flex;
  align-items: stretch;
  background-color: #fff;
  width: 100%;
}

.l_coupon__left {
  flex: 0 0 170px;
  overflow: hidden;
  height: 133px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.l_coupon__right {
  flex: 1 1 auto;
  padding: 8px 10px;
  position: relative;
  background-color: #fff;
}
.l_coupon__image {
  width: 100%;
  overflow: hidden;
  height: 133px;
  background-position: left;
  background-repeat: no-repeat;
  background-size: contain;
}

.c_coupon__title {
  font-size: 13px;
  line-height: 1.38;
  font-weight: bold;
  letter-spacing: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.l_heading {
  position: absolute;
  bottom: 10px;
}

.c_coupon__heading {
  font-size: 22px;
  line-height: 1;
  color: #e03535;
  font-weight: 800;
  margin-top: 3px;
}

.c_coupon__heading.is_android {
  font-size: 20px;
}

.c_coupon__subtitle {
  font-size: 12px;
  line-height: 1.38;
  font-weight: 800;
  letter-spacing: normal;
  color: #e03535;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

/* Footer */
.l_coupon__footer {
  background-image: url('~@/assets/img/premium/tab_on.png');
  background-size: cover;
  background-position: center;
  width: 100%;
  min-height: auto;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  text-align: center;
}

.c_coupon__submit {
  color: #ffffff;
  font-size: 14px;
  padding-top: 10px;
  padding-bottom: 11px;
  font-weight: bold;
  display: block;
}

.c_coupon__submit_expire {
  position: relative;
  width: 57%;
  height: 40px;
  top: 0.5em;
  left: 4em;
  display: block;
}
.c_coupon__submit_expire img {
  width: 100%;
}

.c_coupon__submit_default {
  position: relative;
  width: 36%;
  height: 40px;
  top: 0.7em;
  left: 7em;
  display: block;
}

.c_coupon__submit_default img {
  width: 100%;
}

@media only screen and (max-width: 320px) {
  .l_coupon__left {
    flex: 0 0 140px;
  }

  .c_coupon__heading {
    font-size: 20px;
  }
}
</style>
